import {CalculatorOutputParams} from "../../../../shared/classes/CalculatorOutputParams";
import {CalculatorOptions} from "../../../../shared/classes/CalculatorOptions";

const c = (advanced: boolean | undefined = false, htm: boolean | undefined = false): {options: CalculatorOptions} => {
    return {options: {
        displayCurrency: true,
        round: true,
        isAdvancedMode: advanced,
        isHTMMode: htm
    }};
}

export const outputConfig = [
    // global
    {key: 'average_number_exam_hour', cell: 'K48', label: 'Average number of exam per hour', options: {round: false, isAdvancedMode: false}},
    {key: 'yearly_technologist_radiologist_wages', cell: 'K50', label: 'Yearly Technologist & Radiologist Wages', ...c()},
    {key: 'average_number_exam_year', cell: 'T48', label: 'Average number of exams per year',},
    {key: 'estimated_revenue_year', cell: 'T50', label: 'Estimated revenue per year', ...c()},

    //  Xray Gen Chain failure
    {key: 'xray_number_examinations_saved', cell: 'K56', label: "# Examinations Saved"},
    {key: 'xray_number_revenue_saved', cell: 'K58', label: "# Revenue Saved", ...c()},
    {key: 'xray_number_operating_hours_saved', cell: 'K60', label: "# Operating hours Saved"},
    {key: 'xray_staff_idle_time_cost_avoidance', cell: 'K62', label: "Staff idle time cost avoidance", ...c()},
    {key: 'xray_staff_overtime_cost_avoidance', cell: 'K64', label: "Staff Overtime Cost avoidance", ...c()},
    {key: 'xray_average_admin_fee_costs_avoidance_for_rescheduling_exams',cell: 'K66',label: "Average Admin Fee costs avoidance for rescheduling Exams", ...c() },
    {key: 'xray_average_radiotracer_loss_avoidance_fdg', cell: 'K68', label: "Average Radiotracer loss avoidance (FDG)", ...c()},
    {key: 'xray_imaging_dpt_estimated_benefits', cell: 'K70', label: "Imaging Dpt Estimated Benefits", ...c()},
    {key: 'xray_total_hospital_estimated_benefits_1', cell: 'K72', label: "Total Hospital Estimated Benefits", ...c(undefined, true)},

    {key: 'xray_examinations_transfert_saved', cell: 'K75', label: "# Examinations Transfert Saved", options: {isAdvancedMode: true}},
    {key: 'xray_examinations_transfert_cost_saved', cell: 'K77', label: "# Examinations Transfert Cost Saved", ...c(true)},
    {key: 'xray_patient_transfer_cost_avoidance', cell: 'K79', label: "Patient Transfer cost avoidance", ...c(true)},
    {key: 'xray_htm_labor_productivity_in_hours', cell: 'K83', label: "HTM Labor Productivity in Hours", options: {isHTMMode: true}},
    {key: 'xray_htm_labor_productivity', cell: 'K85', label: "HTM Labor Productivity", ...c(undefined, true)},
    // n'est pas utilisé
    // {key: 'xray_tube_watch_yearly_fee', cell: 'K87', label: "Tube Watch Yearly fee", ...c(true, false)},
    {key: 'xray_total_hospital_estimated_benefits_2', cell: 'K90', label: "Total Hospital Estimated Benefits", ...c(true)},

    // Tube failure with TW
    {key: 'tf_with_tw_examinations_saved', cell: 'T56', label: "# Examinations Saved", options: {isAdvancedMode: false}},
    {key: 'tf_with_tw_revenue_saved', cell: 'T58', label: "# Revenue Saved", ...c(false)},
    {key: 'tf_with_tw_operating_hours_saved', cell: 'T60', label: "# Operating hours Saved", options: {isAdvancedMode: false}},
    {key: 'tf_with_tw_staff_iddle_time_cost_avoidance', cell: 'T62', label: "Staff iddle time cost avoidance", ...c(false)},
    {key: 'tf_with_tw_staff_overtime_cost_avoidance', cell: 'T64', label: "Staff Overtime Cost avoidance", ...c(false)},
    {key: 'tf_with_tw_average_admin_fee_costs_avoidance_for_rescheduling_exams',cell: 'T66',label: "Average Admin Fee costs avoidance for rescheduling Exams", ...c(false)},
    {key: 'tf_with_tw_average_radiotracer_loss_avoidance', cell: 'T68', label: "Average Radiotracer loss avoidance", ...c(false)},
    {key: 'tf_with_tw_imaging_dpt_estimated_benefits', cell: 'T70', label: "Imaging Dpt Estimated Benefits", ...c(false)},
    {key: 'tf_with_tw_total_hospital_estimated_benefits_1', cell: 'T72', label: "Total Hospital Estimated Benefits", ...c(undefined, true)},

    {key: 'tf_with_tw_examinations_transfert_saved', cell: 'T75', label: "# Examinations Transfert Saved", options: {isAdvancedMode: true}},
    {key: 'tf_with_tw_examinations_transfert_cost_saved', cell: 'T77', label: "# Examinations Transfert Cost Saved", ...c(true)},
    {key: 'tf_with_tw_patient_transfer_cost_avoidance', cell: 'T79', label: "Patient Transfer cost avoidance", ...c(true)},
    {key: 'tf_with_tw_htm_labor_productivity_in_hours', cell: 'T83', label: "HTM Labor Productivity in Hours", options: {isHTMMode: true}},
    {key: 'tf_with_tw_htm_labor_productivity', cell: 'T85', label: "HTM Labor Productivity", ...c(undefined, true)},
    {key: 'tf_with_tw_total_hospital_estimated_benefits_2', cell: 'T90', label: "Total Hospital Estimated Benefits", ...c(true)},

    // Tube failure wo TW
    {key: 'tf_without_tw_exams_loss', cell: 'AC56', label: "Exams loss", options: {isAdvancedMode: false}},
    {key: 'tf_without_tw_revenue_loss', cell: 'AC58', label: "Revenue Loss", ...c(false)},
    {key: 'tf_without_tw_operating_hours_lost', cell: 'AC60', label: "# Operating hours Lost", options: {isAdvancedMode: false}},
    {key: 'tf_without_tw_staff_cost_due_to_iddle_time', cell: 'AC62', label: "Staff cost due to iddle time", ...c(false)},
    {key: 'tf_without_tw_staff_overtime_cost', cell: 'AC64', label: "Staff Overtime cost", ...c(false)},
    {key: 'tf_without_tw_average_admin_fee_costs_for_rescheduling_exams', cell: 'AC66', label: "Average Admin Fee costs for rescheduling Exams", ...c(false)},
    {key: 'tf_without_tw_average_radiotracer_loss', cell: 'AC68', label: "Average Radiotracer loss", ...c(false)},
    {key: 'tf_without_tw_imaging_dpt_estimated_loss', cell: 'AC70', label: "Imaging Dpt Estimated Loss", ...c(false)},
    {key: 'tf_without_tw_total_hospital_estimated_loss_1', cell: 'AC72', label: "Total Hospital Estimated Loss", ...c(undefined, true)},

    {key: 'tf_without_tw_examinations_transfert_loss', cell: 'AC75', label: "# Examinations Transfert loss", options: {isAdvancedMode: true}},
    {key: 'tf_without_tw_examinations_transfert_cost_loss', cell: 'AC77', label: "# Examinations Transfert Cost Loss", ...c(true)},
    {key: 'tf_without_tw_patient_transfer_cost', cell: 'AC79', label: "Patient Transfer cost", ...c(true)},
    {key: 'tf_without_tw_htm_labor_loss_in_hours', cell: 'AC83', label: "HTM Labor loss in Hours", options: {isHTMMode: true}},
    {key: 'tf_without_tw_htm_labor_loss', cell: 'AC85', label: "HTM Labor Loss", ...c(undefined, true)},
    {key: 'tf_without_tw_total_hospital_estimated_loss_2', cell: 'AC90', label: "Total Hospital Estimated Loss", ...c(true)},

] as const satisfies ReadonlyArray<Omit<CalculatorOutputParams, 'value'> & { cell: string; key: string; }>;

export type OutputCells = typeof outputConfig[number]['cell'];
export type CalculatorInputFieldsKey = typeof outputConfig[number]['key'];




































